import { OverlayTrigger, Tooltip} from 'react-bootstrap';
import { BiMicrophone } from "react-icons/bi";



const TooltipCallMute = () => {

    return (
        
    <>
        {['top'].map((placement) => (
          <OverlayTrigger
            key={placement}
            overlay={
              <Tooltip id={`tooltip-${placement}`}>
                Mute 
              </Tooltip>
            }
          >
            <div><BiMicrophone size={22}/></div>
          </OverlayTrigger>
        ))}
    </>
     
    )
}
export default TooltipCallMute;